import React from 'react';
function NoRecordFound() {
  return (
    <div className="container-fluid h-100 text-center align-middle mt-5">
      <h6>
        <i className="fa fa-exclamation-triangle fa-2x align-middle"></i>
        <span className="align-middle p-2">No record found.</span>
      </h6>
    </div>
  );
}

export default NoRecordFound;
